import React, { useState } from "react";
import logo from "../../assets/logo.png";
import { Link, useLocation } from "react-router-dom";
import { useMediaQuery } from "@mui/material";
import MenuIcon from "@mui/icons-material/Menu";
import CloseIcon from "@mui/icons-material/Close";
import { useLanguage } from "../../context/LanguageContext";

export default function Navbar() {
  const { language, toggleLanguage } = useLanguage();
  const location = useLocation();
  const isHomePage = location.pathname === "/";
  const isNonMobileScreen = useMediaQuery("(min-width: 1000px)");
  const [isMobileMenuToggled, setIsMobileMenuToggled] = useState(false);

  const navLinks = [
    { name: "Home", id: "home" },
    { name: "About", id: "about" },
    { name: "Services", id: "services" },
    { name: "Project", id: "projects" },
    { name: "Contact", id: "contact" },
  ];

  const getLinkPath = (id) => (isHomePage ? `#${id}` : `/#${id}`);

  return (
    <div className="w-full bg-white sticky top-0 z-20 p-0 m-0">
      <div className="mx-5 lg:mx-20 h-16 flex flex-row justify-between items-center ">
        <Link to="/">
          <img src={logo} alt="logo" className="h-10" />
        </Link>
        {isNonMobileScreen ? (
          <>
            <ul className="flex flex-row gap-8 font-Inter font-extrabold items-center">
              {navLinks.map((link) => (
                <li
                  key={link.id}
                  className="hover:text-[#3aa1ff] hover:cursor-pointer hover:underline underline-offset-[10px]"
                >
                  <a href={getLinkPath(link.id)} className="block">
                    {link.name}
                  </a>
                </li>
              ))}
              <li className="hover:text-[#3aa1ff] hover:cursor-pointer hover:underline underline-offset-[10px]">
                <Link to="/blog" className="block">
                  Blog
                </Link>
              </li>

              {/* Language Switcher */}
              <li className="ml-4">
                <button
                  onClick={toggleLanguage}
                  className="bg-[#131315]/5 hover:bg-[#131315]/10 px-3 py-1.5 rounded-xl border border-gray-100 flex items-center gap-2 transition-all group"
                >
                  <span
                    className={`text-xs font-bold ${language === "en" ? "text-[#3aa1ff]" : "text-gray-400"}`}
                  >
                    EN
                  </span>
                  <div className="w-[1px] h-3 bg-gray-200"></div>
                  <span
                    className={`text-xs font-bold ${language === "fr" ? "text-[#3aa1ff]" : "text-gray-400"}`}
                  >
                    FR
                  </span>
                </button>
              </li>
            </ul>
            <a
              href={getLinkPath("contact")}
              className="bg-[#3aa1ff] hover:bg-[#131315] pr-3 pl-3 pt-2 pb-2 rounded-full transition-all"
            >
              <span className="flex flex-row text-white ">
                <span>
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    viewBox="0 0 24 24"
                    fill="currentColor"
                    className="w-6 h-6 pr-2"
                  >
                    <path d="M1.5 8.67v8.58a3 3 0 0 0 3 3h15a3 3 0 0 0 3-3V8.67l-8.928 5.493a3 3 0 0 1-3.144 0L1.5 8.67Z" />
                    <path d="M22.5 6.908V6.75a3 3 0 0 0-3-3h-15a3 3 0 0 0-3 3v.158l9.714 5.978a1.5 1.5 0 0 0 1.572 0L22.5 6.908Z" />
                  </svg>
                </span>
                Get in touch
              </span>
            </a>
          </>
        ) : (
          <>
            <button
              onClick={() => setIsMobileMenuToggled(!isMobileMenuToggled)}
            >
              <MenuIcon sx={{ fontSize: "30px" }} />
            </button>
          </>
        )}

        {/* MOBILE NAV */}
        {!isNonMobileScreen && isMobileMenuToggled && (
          <div className="bg-white fixed h-full w-full right-0 bottom-0 z-50 animate-in slide-in-from-right duration-300">
            <div className="flex items-center justify-end w-full">
              <button
                className="m-5"
                onClick={() => setIsMobileMenuToggled(false)}
              >
                <CloseIcon sx={{ fontSize: "30px" }} />
              </button>
            </div>
            <div className="w-full flex flex-col items-center">
              <ul className="font-Poppins w-full">
                {navLinks.map((link) => (
                  <li
                    key={link.id}
                    className="h-16 flex items-center justify-center hover:bg-[#131315] w-full hover:text-white transition-all"
                  >
                    <a
                      href={getLinkPath(link.id)}
                      className="w-full h-full flex items-center justify-center"
                      onClick={() => setIsMobileMenuToggled(false)}
                    >
                      {link.name}
                    </a>
                  </li>
                ))}
                <li className="h-16 flex items-center justify-center hover:bg-[#131315] w-full hover:text-white transition-all">
                  <Link
                    to="/blog"
                    className="w-full h-full flex items-center justify-center"
                    onClick={() => setIsMobileMenuToggled(false)}
                  >
                    Blog
                  </Link>
                </li>
                {/* Language Switcher for Mobile */}
                <li className="h-20 flex items-center justify-center border-t border-gray-100 mt-4">
                  <button
                    onClick={() => {
                      toggleLanguage();
                      setIsMobileMenuToggled(false);
                    }}
                    className="bg-[#131315]/5 px-6 py-2.5 rounded-2xl flex items-center gap-4 transition-all"
                  >
                    <span
                      className={`text-sm font-bold ${language === "en" ? "text-[#3aa1ff]" : "text-gray-400"}`}
                    >
                      ENGLISH
                    </span>
                    <div className="w-[1px] h-4 bg-gray-200"></div>
                    <span
                      className={`text-sm font-bold ${language === "fr" ? "text-[#3aa1ff]" : "text-gray-400"}`}
                    >
                      FRANÇAIS
                    </span>
                  </button>
                </li>
              </ul>
            </div>
          </div>
        )}
      </div>
    </div>
  );
}
